<template>
    <div>
        <FailedEmails
            v-if="reportId == CREPORT.TYPE.FAILED_EMAILS"
            :data="data"
        />

        <RemindersDetail
            ref="remindersDetail"
            v-if="
                reportId == CREPORT.TYPE.REMINDERS_DETAIL ||
                reportId == 'reminder'
            "
            :data="data"
        />
    </div>
</template>
<script>
import CREPORT from "@/constants/report.js";
import FailedEmails from "@/module/report/module/communications/failed-emails";
import RemindersDetail from "@/module/report/module/communications/reminders-detail";
export default {
    components: {
        RemindersDetail,
        FailedEmails
    },
    props: {
        data: {
            default() {},
            type: Object
        }
    },
    computed: {
        reportId() {
            return this.$route.params.id;
        }
    },
    data() {
        return { CREPORT: CREPORT };
    },
    methods: {
        resetCheckBoxes() {
            this.$refs.remindersDetail.resetCheckBoxes();
        }
    }
};
</script>
